<div class="tree-card" [class.selected]="isSelected">
  <div class="card-content" (click)="onCardClick()">
    <img *ngIf="node.img" [src]="node.img" [alt]="node.description" class="card-image">
    <div class="card-info">
      <h3 class="card-title">{{ node.description }}</h3>

      <!-- Node with children -->
      <p class="card-description" *ngIf="node.nodes && node.nodes.length > 0">
        {{ node.nodes.length }} items
      </p>

      <!-- Node with models -->
      <p class="card-description" *ngIf="node.models && node.models.length > 0">
        {{ node.models.length }} options
      </p>
    </div>
    <div class="toggle-container" (click)="$event.stopPropagation()">
      <label class="switch">
        <input
          type="checkbox"
          [checked]="isSelected"
          (change)="handleToggleChange($event)">
        <span class="slider">
          <span class="circle">
            <svg class="checkmark" viewBox="0 0 24 24">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
            </svg>
            <svg class="cross" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
            </svg>
          </span>
        </span>
      </label>
    </div>
  </div>
</div>
